module Tapas.Bindings {
    export class AsyncPriceLoad {
        public update(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var forceUpdate = ko.unwrap(valueAccessor());
            var data = new Ftw.Data();        

            //TODO: Rewrite from jQuery
            var ele = $(element);
            var priceMissing = ele.find(".price.asyncLoad"); 
            if (priceMissing.length > 0) {
                var ids = "count=" + priceMissing.length;
                var count = 0;

                priceMissing.each(function () {
                    ids += "&productid[" + count + "]=" + $(this).data("productid");
                    ids += "&key[" + count + "]=" + $(this).data("productkey");
                    count += 1;
                })               
                data.postForm('/Handlers/Firstweb.ERP.PriceCache.ashx?cmd=getpricesandstocks', ids).then((result) => {
                    if (result.ERPStatus.Success) {
                        $.each(result.Data, function (key, data) {
                            var priceEle = $(".price.asyncLoad[data-productkey='" + key + "']");
                            priceEle.find(".brutto .bPrice").html(data.PriceInfo.Tags["Firstweb:ErpPriceInfo.BruttoAmountFormattedNoSymbol"]);
                            priceEle.find(".netto .nPrice").html(data.PriceInfo.Tags["Firstweb:ErpPriceInfo.NettoPriceFormattedNoSymbol"]);
                            priceEle.parent().parent().find(".stock").attr("data-stock", data.StockInfo.StockQuantity);

                            if (data.PriceInfo.HasQuantityPrices == true) {
                                priceEle.parent().find("#dLabel").removeClass("hideQuantity").addClass("loadQuantity");
                            }
                        });
                    }
                    else {
                        //TODO : Show some sort of error to the user based on the status
                        console.log('ErpStatus not Successfull');
                        
                    }})
                    .catch((error) => {
                        //TODO : Show some sort of error to the user - shut down shopping?
                        console.log("We catch fatal errors here - ex : no access to the ERP on local dev machines");
                    })
                    .finally(() => {
                        //Allways remove the loaders
                        $(".price.asyncLoad").removeClass("asyncLoad");
                    });
            }
        }
    }
    ko.bindingHandlers['asyncPriceLoad'] = new AsyncPriceLoad();
}